/**
 * 블소 - 문파
 */
import { Fragment } from 'react';
import { setYMDDateFormat, strReplaceUrl } from "@utils/index";
import { IGuild, ISetGuild, l10nType } from "@type/index";

export const setGuildItem = (item: IGuild): ISetGuild | null => {
    return item && typeof item === 'object' ? {
        ...item,
        url: `/world/guild/LIVE/${item?.serverId}/${strReplaceUrl(item?.guildName)}`
    } : null;
};

export const GuildArticle = ({ item, l10n }: {item: IGuild; l10n: l10nType;}) => {
    const data = setGuildItem(item);

    if(!data) {
        return <Fragment />;
    }

    const { url, guildName, serverName, leaderCharacterName, level, createdDatetime } = data;
    return <div className="searc-item-content"> 
        <div className="search-item-title">
            <a href={url} dangerouslySetInnerHTML={{__html: guildName}}></a>
        </div>   
        <div className="search-item-info">{serverName}</div>  
        <div className="search-item-info">
            <span>문파장</span>
            <span>{leaderCharacterName}</span>
            <span>Lv {level}</span>
            <span>창설일 {setYMDDateFormat(createdDatetime)}</span>
        </div>    
  </div>;
};